var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "c-search-box",
        {
          ref: "searchbox",
          attrs: { isShowSearch: false },
          on: { enter: _vm.getList },
        },
        [
          _c("template", { slot: "search" }, [
            _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("c-plant", {
                  attrs: { type: "search", name: "plantCd" },
                  on: { input: _vm.getList },
                  model: {
                    value: _vm.searchParam.plantCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "plantCd", $$v)
                    },
                    expression: "searchParam.plantCd",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("c-dept", {
                  attrs: { type: "search", name: "deptCd", label: "관리부서" },
                  on: { input: _vm.getList },
                  model: {
                    value: _vm.searchParam.deptCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "deptCd", $$v)
                    },
                    expression: "searchParam.deptCd",
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        2
      ),
      _c("c-table", {
        ref: "table",
        attrs: {
          title: "장소 목록",
          parentProperty: "upMdmLocationId",
          customID: "mdmLocationId",
          columns: _vm.gridColumns,
          data: _vm.grid.data,
          gridHeight: _vm.grid.height,
          filtering: true,
          columnSetting: false,
          isFullScreen: false,
          selection: _vm.popupParam.type,
          rowKey: "mdmLocationId",
        },
        on: { rowDblclick: _vm.rowDblclick },
      }),
      _c("div", { staticClass: "space-bottom-button" }),
      _c(
        "div",
        { staticClass: "search-box-btn" },
        [
          _c(
            "q-btn-group",
            { attrs: { outline: "" } },
            [
              _c("c-btn", {
                attrs: { label: "선택", icon: "check", color: "teal-5" },
                on: { btnClicked: _vm.select },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }